import styled from 'styled-components'

export const PDFContainer = styled.div`
  margin: 0 -12px;
  canvas {
    width: 100% !important;
    height: auto !important;
  }
`
